/*****
 * Created by Allan on 2021/04/02.
 * Contact 84880528@qq.com.
 * *****/
import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import tagsview from "./tagsview";
import applist from "./applist";
import global from "./global";
import payment from "./payment";

Vue.use(Vuex);

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production', //在非生产环境下，使用严格模式
    modules:{
        user,
        tagsview,
        applist,
        global,
        payment,
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js